import { useEffect } from 'react';
import { registerOpenModal } from './modalRegistry';

export function useEscapeClose(onClose: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, enabled]);

  // An escape-closable overlay is open: suppress the global feature hotkeys
  // (see hooks/modalRegistry.ts). Separate effect so it does not re-register
  // every time the caller passes a fresh `onClose` closure.
  useEffect(() => {
    if (!enabled) return;
    return registerOpenModal();
  }, [enabled]);
}
